import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { CallOverlay } from '../../../../common/components/call-overlay';
import * as call from '../../../call';
import { toggleClosedCaptionsOpen, useCaptions } from '../../../captions';
import { isPatient } from '../../../call/helpers/person-types';
import { MOBILE_LAYOUT_BODY_CSS_MODIFIER } from '../../constants';
import MainView from '../MainView';
import Participants from '../Participants';
import CallActions from '../CallActions';
import { EndCallConfirmationPopup } from '../../../call/components';
import { useDeviceOrientation, useIsCallFrameOpen } from '../../hooks';
import './GroupCall.scss';
import { CallFrame } from '../../../extensions-framework/components/call-frame';
import { getGridViewOpenState } from '../../selectors';
import HeaderMainView from '../HeaderMainView';
import HeaderCallFrame from '../HeaderCallFrame';
import { ClosedCaptions } from '@doxyme/ui';
const GroupCall = () => {
    const selfParticipant = useSelector(call.selectors.getSelfParticipant);
    const activeParticipant = useSelector(call.selectors.getActiveParticipant);
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    const isGridOpen = useSelector(getGridViewOpenState);
    const deviceOrientation = useDeviceOrientation();
    const { isCaptionsOpen, formattedCaptions, bottomOffset, translatedText } = useCaptions();
    const isCallFrameOpen = useIsCallFrameOpen();
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList.add(MOBILE_LAYOUT_BODY_CSS_MODIFIER);
        return () => {
            dispatch(call.actions.setCurrentStreamId(undefined));
            document.body.classList.remove(MOBILE_LAYOUT_BODY_CSS_MODIFIER);
        };
    }, []);
    useEffect(() => {
        if (!currentParticipant) {
            dispatch(call.actions.setCurrentStreamId(activeParticipant?.id));
        }
    }, [activeParticipant?.id]);
    const onChangeCurrentParticipant = useCallback((participant) => {
        dispatch(call.actions.setCurrentStreamId(participant.id));
        dispatch(call.actions.updateVideoSubscriptions);
    }, []);
    const onCloseClosedCaptions = useCallback(() => {
        dispatch(toggleClosedCaptionsOpen(false, isPatient()));
    }, []);
    const isMainViewShown = !isCallFrameOpen && Boolean(currentParticipant);
    const isToolbarOpen = isMainViewShown || isGridOpen;
    return (<div className="ml-group-call">
      <div className="ml-group-call__main">
        {isCaptionsOpen && (<ClosedCaptions bottomOffset={bottomOffset} captions={formattedCaptions} onClose={onCloseClosedCaptions} translatedText={translatedText}/>)}

        <CallOverlay hasVideo={selfParticipant.hasVideo} hasAudio={selfParticipant.hasAudio}/>
        <CallFrame className="ml-group-call__call_frame"/>

        <div className="ml-group-call__header">
          {isMainViewShown ? (<HeaderMainView key={deviceOrientation}/>) : (<HeaderCallFrame key={deviceOrientation}/>)}
        </div>

        {isMainViewShown && (<MainView activeParticipant={activeParticipant} currentParticipant={currentParticipant} onChangeCurrentParticipant={onChangeCurrentParticipant}/>)}

        {isToolbarOpen && (<div className={classnames({
                'ml-group-call__toolbar': true,
                'ml-group-call__toolbar--main-view': isCallFrameOpen,
            })}>
            <CallActions key={deviceOrientation} hasCameraAccess={selfParticipant.hasCameraAccess} hasMicrophoneAccess={selfParticipant.hasMicrophoneAccess} hasAudio={selfParticipant.hasAudio} hasVideo={selfParticipant.hasVideo}/>
          </div>)}
      </div>
      <div className="ml-group-call__footer">
        <Participants selfParticipant={selfParticipant}/>
      </div>

      <EndCallConfirmationPopup />
    </div>);
};
export default GroupCall;
